import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "./styles.css";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <Suspense fallback={<div className="loading-shell">Loading SURBANCO</div>}>
        <App />
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);
